// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__mud9_","list":"BalanceDue_list__2tRtG","listRow":"BalanceDue_listRow__16gfD","total":"BalanceDue_total__iyIsY"};